import { render, staticRenderFns } from "./Deposit.vue?vue&type=template&id=38c4fd4a&scoped=true"
import script from "./Deposit.vue?vue&type=script&lang=js"
export * from "./Deposit.vue?vue&type=script&lang=js"
import style0 from "./Deposit.vue?vue&type=style&index=0&id=38c4fd4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c4fd4a",
  null
  
)

export default component.exports